module.exports = __webpack_public_path__ + "static/media/190x190px_minainstrument_grey.d6e0b78a.png";